
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router'
import { HttpEvent, HttpInterceptor, HttpHandler, HttpRequest, HttpErrorResponse } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { Observable, throwError } from 'rxjs';
import { AppSettings } from '../configuration/appsettings.config';
import { DataShareService } from './datashare.service'

@Injectable()
export class HttpServiceInetrceptor implements HttpInterceptor {
  constructor(private router: Router, private dataShareService: DataShareService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

   

    //set the Authorization token in header..
      request = request.clone({
        setHeaders: {
          'X-XSRF-TOKEN': this.getCookieValue("XSRF-TOKEN")
        }
      });
     
    return next.handle(request)
      .pipe(catchError((errorResponse: HttpErrorResponse) => {

        if (errorResponse instanceof HttpErrorResponse) {
          // Invalid Model. Server couldn't validate the Model..
      
          if (errorResponse.status == 400) {
            if (typeof (errorResponse.error) == "string") {
              if (errorResponse.error.indexOf('serverside404page') > 0) {
                AppSettings.removeAllTokens();
                this.router.navigate(["/"])
              }
            }
            else {
              return throwError(errorResponse.error);
            }
            
          }
          //UnAutherized Access returned from server...
          else if (errorResponse.status === 401) {
            
            //delete the token and redirect user to login page..
            AppSettings.removeAllTokens();
            this.router.navigate(["/"])
          }
          //for all other error. redirect user to the errro page. http:500
          else {
            //Check if the error has been caused by the Client..
             
            var errorObject: any = {};
            var errorProp: any = {};
            if (errorResponse.error == null) {
              errorProp.ErrorMessage = errorResponse.message;
              errorProp.IsDevelopment = AppSettings.IsDevelopment;
              errorObject.error = errorProp;
              errorResponse = errorObject;
            }
            this.router.navigate(["error/"]);
            this.dataShareService.onError(errorResponse);
          }
        }
       // return throwError(errorResponse);
      }));




  }

  private getCookieValue(cookieName: string) {
    
    const allCookies = decodeURIComponent(document.cookie).split("; ");
    for (let i = 0; i < allCookies.length; i++) {
      const cookie = allCookies[i];
      if (cookie.startsWith(cookieName + "=")) {
       
        return cookie.substring(cookieName.length + 1);
      }
    }
    return "";
  }
}
